<script lang="ts">
export default { name: 'PinRestore' };
</script>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

// COMPONENTS
import GStepper from '@/components/GStepper/index.vue';
import GStepperItem from '@/components/GStepper/components/GStepperItem.vue';
import PinRestoreCode from '../PinRestoreCode/index.vue';

// COMPOSABLES
import { useRoute, useRouter } from 'vue-router';
import { usePinRestore } from './usePinRestore';

import type { PinEmits, PinRestoreNavigation } from '../../types/pin.type';

const JumioAuthenticationGate = defineAsyncComponent(
  () => import('@/shared/jumio/views/JumioAuthenticationGate/index.vue')
);

const emits = defineEmits<PinEmits>();
const route = useRoute();
const router = useRouter();

const navigation: PinRestoreNavigation = {
  getCurrentPath: () => route.path,
  goToMovements: () => {
    router.push({ name: 'movements' });
  },
};

const {
  step,
  isVerificationOpen,
  verificationAttempt,
  handleRightHeader,
  onVerified,
  onCancelVerification,
  PinRestoreStep,
} = usePinRestore(emits, navigation);
</script>

<template>
  <g-stepper
    v-model="step"
    @click-right-header="handleRightHeader"
    data-test="pin:restore"
  >
    <g-stepperItem dot title="Crear PIN" :value="PinRestoreStep.PIN">
      <PinRestoreCode @close="emits('close')" />
    </g-stepperItem>
    <g-stepperItem
      dot
      title="Verificación"
      :value="PinRestoreStep.VERIFICATION"
    >
      <JumioAuthenticationGate
        :key="verificationAttempt"
        :model-value="isVerificationOpen"
        data-test="jumio-gate:pin-restore"
        @verified="onVerified"
        @cancel="onCancelVerification"
      />
    </g-stepperItem>
  </g-stepper>
</template>
